import React from "react";
import "../styles/home.css"
import PostList from "../components/PostList";
const Home = () => {
  
  return (
    <div className="home-container">
    <div className="welcome-section">
      <h2>Welcome to the Blog!</h2>
      <p>Explore our latest posts or create your own!</p>
    </div>
    <PostList/>
  </div>
);
};
export default Home;
